import React from "react";

interface AusentismoRowProps {
  record: {
    id: number;
    name: string;
    branch: string;
    falta: string;
    tipo: string;
    position: string;
  };
}

const AusentismoRow: React.FC<AusentismoRowProps> = ({ record }) => {
  return (
    <tr style={{ borderBottom: "1px solid #f3f4f6" }}>
      <td className="py-2 px-4 text-start">
        <div className="d-flex align-items-center">
          <div
            className="d-flex align-items-center justify-content-center me-3 shadow-sm"
            style={{
              width: "32px",
              height: "32px",
              backgroundColor: "#e0f2fe",
              color: "#0284c7",
              borderRadius: "50%",
              fontSize: "0.8rem",
              fontWeight: 700,
            }}
          >
            {record.name.charAt(0)}
          </div>
          <span
            style={{
              color: "#1f2937",
              fontWeight: 600,
              fontSize: "0.875rem",
            }}
          >
            {record.name}
          </span>
        </div>
      </td>
      <td className="py-2 px-4 text-start">
        <span
          style={{
            color: "#4b5563",
            fontSize: "0.85rem",
          }}
        >
          {record.branch}
        </span>
      </td>
      <td className="py-2 px-4 text-start">
        <span
          className="px-3 py-1 rounded-pill"
          style={{
            backgroundColor: "#f3f4f6",
            color: "#374151",
            fontSize: "0.75rem",
            fontWeight: 600,
            border: "1px solid #e5e7eb",
          }}
        >
          {record.position}
        </span>
      </td>
      <td className="py-2 px-4 text-start">
        <div className="d-flex align-items-center justify-content-start text-muted">
          <i
            className="fa-regular fa-calendar me-2"
            style={{ fontSize: "0.8rem", color: "#9ca3af" }}
          />
          <span style={{ fontSize: "0.85rem" }}>{record.falta}</span>
        </div>
      </td>
    </tr>
  );
};

export default AusentismoRow;
